var map = {
	"./arrowl.png": "vYsi",
	"./arrowr.png": "xaIb",
	"./avatar.png": "TUGy",
	"./banner.png": "GTZ6",
	"./bg.png": "P24z",
	"./champavatar.png": "DJBI",
	"./champlabel.png": "myie",
	"./chamption.png": "UeJd",
	"./crown.png": "2MiZ",
	"./default.png": "a83/",
	"./footer.png": "7qC3",
	"./haixuan.png": "y3N2",
	"./header.png": "Lcds",
	"./hourback.png": "Lvbp",
	"./hourback1.png": "kduk",
	"./hover.png": "A+5P",
	"./living.png": "lp8G",
	"./logo.png": "nWR2",
	"./master.png": "iZln",
	"./mastertitle.png": "Pnsv",
	"./none.png": "hHRA",
	"./pk.png": "s+1l",
	"./pkback.png": "PbIQ",
	"./rankno1.png": "oZX0",
	"./rankno2.png": "xVLU",
	"./rankno3.png": "wJrn",
	"./ranknon.png": "6AXw",
	"./revive.png": "gmvz",
	"./rule41back.png": "mnt6",
	"./rule42back.png": "sj9+",
	"./rule436back.png": "tawx",
	"./rule44back.png": "LysY",
	"./rule45back.png": "8TuT",
	"./rule4tab.png": "Vdif",
	"./rule4tabs.png": "A5Rc",
	"./ruletabs.png": "qwdK",
	"./sideback.png": "HmCP",
	"./sideselect.png": "ZWKB",
	"./tab1.png": "x0PE",
	"./tab1rank.png": "TZLC",
	"./tab1s.png": "uOu3",
	"./tab2.png": "NqXM",
	"./tab2s.png": "7wQw",
	"./tab2tab.png": "WY3g",
	"./tab2tabline.png": "TzVi",
	"./tab2tabs.png": "oaQk",
	"./tab3.png": "2yoP",
	"./tab3s.png": "mJkT",
	"./tab4.png": "6dCx",
	"./tab4s.png": "jt62",
	"./timeback.png": "2XPV",
	"./titleback.png": "+1OH",
	"./vs.png": "NkJE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Hj7";